import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';
import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';

const NEWS_LOCALES = ['en-us', 'en-ca', 'en-in', 'en-au', 'pt-br', 'es-mx'];

export default function isNewsEnabled(): boolean {
    const userConfig = getUserConfiguration();
    const userLocale = userConfig?.SessionSettings?.UserCulture;
    const isSupportedLocale = NEWS_LOCALES.some(locale => locale === userLocale?.toLowerCase());

    return (
        isFeatureEnabled('tri-newsDev') ||
        ((isFeatureEnabled('tri-news') || isFeatureEnabled('tri-newsCompact')) &&
            !userConfig.SessionSettings.IsPremiumConsumerMailbox &&
            !userConfig.IsConsumerChild &&
            !isBrowserIE() &&
            // User turned off view 'Turn of News' right click UI
            !getIsBitSet(ListViewBitFlagsMasks.HideNews) &&
            isSupportedLocale)
    );
}
